/**
 * L'etichetta di ambito (SPEC-026 §2.7): «Borsa» o «Crypto».
 *
 * Un solo componente per ogni posto in cui un'entità dichiara a quale dei due
 * mondi appartiene — l'identità di un titolo, l'intestazione di un
 * portafoglio, la scheda di una connessione, la riga di un flusso. Tinta
 * **neutra** di proposito: non è un avviso né uno stato, è un'etichetta di
 * catalogo, come il tipo di strumento accanto a cui sta. Un colore forte la
 * farebbe leggere come qualcosa da fare.
 *
 * Con più ambiti (`domains`) si mostra un badge per ciascuno, nell'ordine
 * borsa → crypto; una lista vuota non mostra nulla.
 */

import { ASSET_DOMAIN_LABELS, type AssetDomain } from '@/lib/asset-domain';
import { Badge } from './index';

const TITLES: Record<AssetDomain, string> = {
  stock:
    'Ambito borsa: strumenti con ISIN negoziati su un mercato con un orario (azioni, ETF, obbligazioni, ETN — anche su crypto).',
  crypto:
    'Ambito crypto: monete e token nativi, identificati dal simbolo e negoziati 24/7 su un exchange. Le operazioni automatiche restano entro le prime 200 per capitalizzazione.',
};

const ORDER: AssetDomain[] = ['stock', 'crypto'];

export function DomainBadge({ domain }: { domain: AssetDomain }) {
  return (
    <Badge title={TITLES[domain]}>
      <span className="domain-badge" data-domain={domain}>
        {ASSET_DOMAIN_LABELS[domain]}
      </span>
    </Badge>
  );
}

export function DomainBadges({ domains }: { domains: readonly AssetDomain[] }) {
  const shown = ORDER.filter((domain) => domains.includes(domain));
  if (shown.length === 0) return null;
  return (
    <>
      {shown.map((domain) => (
        <DomainBadge key={domain} domain={domain} />
      ))}
    </>
  );
}
